// @flow

import styled from 'styled-components';
import type { Theme } from '../../../../types';

export default styled<any, Theme>('label')`
  align-items: center;
  display: flex;
  margin-right: 2rem;

  &:last-child {
    margin-right: 0;
  }
`;
